// Import api models.
import {
	Peril,
	PolicyLoss
} from '@app/models/api';

interface ClaimState {
	currentClaim: PolicyLoss;
	previousClaims: PolicyLoss[];
	perils: Peril[];
};


const getInitialState = (): ClaimState => {
	return {
		currentClaim: new PolicyLoss(),
		previousClaims: [],
		perils: []
	};
};

export { getInitialState, ClaimState };